import { createPortal } from 'react-dom';

import { DhlLoader } from '@/vendor/dhlReactInitial';

const CustomLoader: React.FC = () => {
    return createPortal(
        <div
            className="tw-fixed tw-inset-0 tw-z-[99999] tw-flex tw-items-center tw-justify-center"
            style={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }}
        >
            <DhlLoader type="ring-dual" size="sm" />
        </div>,
        document.body,
    );
};

export default CustomLoader;
